(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["almond-hero-ingredient"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.al-ingredient').forEach(function (root) {
    var visual = root.querySelector('.al-ingredient-visual');
    if (!visual) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            visual.classList.add('is-in');
            io.unobserve(visual);
          }
        });
      }, { threshold: 0.35, rootMargin: '0px 0px -10% 0px' });
      io.observe(visual);
    } else {
      visual.classList.add('is-in');
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-ingredient"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.al-ingredient').forEach(function (root) {
    var visual = root.querySelector('.al-ingredient-visual');
    if (!visual) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            visual.classList.add('is-in');
            io.unobserve(visual);
          }
        });
      }, { threshold: 0.35, rootMargin: '0px 0px -10% 0px' });
      io.observe(visual);
    } else {
      visual.classList.add('is-in');
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-stories"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var POS = ['pos-front', 'pos-mid', 'pos-back'];

    document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
      var section  = carousel.closest('.vsr-stories');
      var slides   = Array.from(carousel.querySelectorAll('.vsr-slide'));
      var dots     = Array.from(carousel.querySelectorAll('.vsr-dot'));
      if (slides.length < 2) return;

      var reduced  = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var interval = parseInt(section.dataset.interval || '5') * 1000;
      var depth    = parseInt(section.dataset.depth   || '3');
      var visible  = Math.min(depth, POS.length);
      var order    = slides.map(function (_, i) { return i; });
      var busy     = false;
      var timer;

      function applyPositions () {
        slides.forEach(function (s) { s.className = 'vsr-slide'; });
        for (var i = 0; i < Math.min(visible, order.length); i++) {
          slides[order[i]].classList.add(POS[i]);
        }
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', order[0] === i);
        });
      }

      function advance () {
        if (busy) return;
        busy = true;

        var exitIdx = order[0];
        slides[exitIdx].classList.remove('pos-front');
        slides[exitIdx].classList.add('is-exiting');
        order.push(order.shift());

        /* Immediately move visible cards to their new positions */
        for (var i = 0; i < Math.min(visible, order.length); i++) {
          if (order[i] !== exitIdx) {
            slides[order[i]].className = 'vsr-slide ' + POS[i];
          }
        }
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', order[0] === i);
        });

        setTimeout(function () {
          slides[exitIdx].classList.remove('is-exiting');
          applyPositions();
          busy = false;
        }, 620);
      }

      function startTimer () {
        if (reduced) return;
        timer = setInterval(advance, interval);
      }
      function stopTimer () { clearInterval(timer); }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () { stopTimer(); advance(); startTimer(); });
      });

      carousel.addEventListener('mouseenter', stopTimer);
      carousel.addEventListener('mouseleave', startTimer);

      applyPositions();
      startTimer();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
